import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-5 mb-4 bg-light rounded-3" }
const _hoisted_2 = { class: "container-fluid py-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "display-5 fw-bold" }, "Core", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "col-md-8 fs-4" }, "Admin UI", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "signin-button" }
const _hoisted_7 = {
  key: 1,
  class: "btn btn-success btn-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (!_ctx.isSignedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.isSigningIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
              name: 'Login',
              query: {
                redirect: '/home',
              },
            },
                    class: "btn btn-success btn-lg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Logga in")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSigningIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_fa_icon, { icon: "spinner" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}